module.exports = function() {
  return new Worker(__webpack_public_path__ + "071b0a3bb38c7e88e937.worker.js");
};